import React, {useEffect, useState} from 'react'
import Box from '@mui/material/Box'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import {
  StyledCheckbox,
  StyledTableContactReportCell,
  StyledTableRow,
  StyledTypography,
  StyledFlaggedIcon,
  IconCircularDiv,
  FlagIconDivContainer,
  StyledTableCell
} from './Styles'
import ActionMenu from '../ActionMenu'
import {useLlmApi} from '../../../api/llmAskGivePrismSearch'
import {useDispatch, useSelector} from 'react-redux'
import {
  removeExisitingProspectContentSummary,
  setGenerateEmailRowData,
  setProspectContentSummary
} from '../../../store/prospectSegment/allProspectsData/allProspectsDataSlice'
import {CircularProgress} from '@mui/material'
import parse from 'html-react-parser'
import PropTypes from 'prop-types'
import {StyledToolTip} from '../Styles'
import {formatGivingCapacity, formatStateAbbreivation} from '../../../helper/commonHelper'
import InterestCell from './InterestCell'
import EducationPopover from './EducationPopover'

const TableDataComponent = (props) => {
  const {
    row,
    headers,
    handleRowCheckboxChange,
    showCheckboxes,
    isActionRequired,
    hasAccordian,
    actionMenuList,
    handleTableRowClick,
    resetInterestToggle = false,
    statesValue
  } = props
  const [open, setOpen] = useState(false)
  const [displayCount, setDisplayCount] = useState(3)
  const [showLess, setShowLess] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const [clickedColumn, setClickedColumn] = useState(null)
  const prospectSummary = useSelector((state) => state.getAllProspectsData.contentSummary)
  useEffect(() => {
    if (row || resetInterestToggle) {
      setDisplayCount(3)
      setShowLess(false)
    }
  }, [row, resetInterestToggle])

  const handleShowMore = (event, interestLength) => {
    setDisplayCount(displayCount + (interestLength - 3))
    setShowLess(true)
    event.stopPropagation()
  }

  const handleShowLess = (event) => {
    setDisplayCount(3)
    setShowLess(false)
    event.stopPropagation()
  }

  const handlePopoverOpen = (event, columnKey) => {
    setAnchorEl(event.currentTarget)
    setClickedColumn(columnKey)
    event.stopPropagation()
  }

  const handlePopoverClose = (event) => {
    setAnchorEl(null)
    setClickedColumn(null)
  }

  const openPopover = Boolean(anchorEl)

  const {isMutating, data: generatedSummary, error} = useLlmApi('generate_content/')
  const dispatch = useDispatch()
  const askGivePrismFilters = useSelector((state) => state.askGivePrism.filters)

  const showContactReport = (row) => {
    setOpen(!open)
  }

  useEffect(() => {
    if (!isMutating && generatedSummary && !error) {
      dispatch(removeExisitingProspectContentSummary(row.uniqueConstituentIdentifier))
      dispatch(
        setProspectContentSummary({
          id: row.uniqueConstituentIdentifier,
          content: generatedSummary[0]?.prospect_summaries
        })
      )
    }
  }, [isMutating, error, generatedSummary, dispatch, row])

  const handleClick = (event, row) => {
    if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'DIV') {
      if (hasAccordian) {
        if (Object.hasOwn(askGivePrismFilters, 'uniqueConstituentIdentifier')) {
          !prospectSummary.filter((e) => e.id === row.uniqueConstituentIdentifier).length > 0 &&
            dispatch(setProspectContentSummary({id: row.uniqueConstituentIdentifier, content: row.contactReport}))
        }

        showContactReport(row)
        dispatch(setGenerateEmailRowData({}))
      } else if (isActionRequired && !hasAccordian) {
        handleTableRowClick(event, row)
      } else {
        event.stopPropagation()
      }
    }
  }

  const handleCellClick = (event, key, rowData) => {
    event.stopPropagation()
  }

  const getFormattedRowData = (key, rowData) => {
    if (key === 'givingCapacity') {
      return formatGivingCapacity(rowData)
    } else if (key === 'state') {
      return formatStateAbbreivation(statesValue, rowData)
    } else {
      return rowData
    }
  }

  return (
    <>
      <StyledTableRow onClick={(event) => handleClick(event, row)}>
        {showCheckboxes && (
          <TableCell>
            <StyledCheckbox
              size="small"
              color="primary"
              inputProps={{
                'aria-label': 'bookmark'
              }}
              onChange={(event) => handleRowCheckboxChange(event, row.uniqueConstituentIdentifier)}
              checked={Boolean(row.selected)}
            />
          </TableCell>
        )}

        {headers?.map((key) => {
          if (key === 'interestTag') {
            return (
              <React.Fragment key={key}>
                <InterestCell
                  interests={row[key]}
                  handleShowMore={(event) => handleShowMore(event, row[key].length)}
                  displayCount={displayCount}
                  handleShowLess={handleShowLess}
                  showLess={showLess}
                  handleCellClick={(event) => handleCellClick(event, key, row)}
                />
              </React.Fragment>
            )
          }
          if (key === 'college' || key === 'degree') {
            return (
              <React.Fragment key={key}>
                <StyledTableCell>
                  <EducationPopover
                    content={row}
                    columnKey={key}
                    anchorEl={anchorEl}
                    openPopover={openPopover}
                    handlePopoverOpen={(event) => handlePopoverOpen(event, key)}
                    handlePopoverClose={(event) => handlePopoverClose(event)}
                    clickedColumn={clickedColumn}
                  />
                </StyledTableCell>
              </React.Fragment>
            )
          }
          return (
            <React.Fragment key={key}>
              <TableCell sx={{textWrap: 'nowrap'}}>
                {Object.hasOwn(row, key) && (
                  <StyledTypography component="span">
                    {getFormattedRowData(key, row[key])}
                    {Boolean(row.isManaged) && key === 'fullName' && (
                      <StyledToolTip placement="right-end" arrow title="This prospect is managed by a gift officer.">
                        <IconButton onClick={(event) => event.stopPropagation()}>
                          <FlagIconDivContainer>
                            <IconCircularDiv>
                              <StyledFlaggedIcon />
                            </IconCircularDiv>
                          </FlagIconDivContainer>
                        </IconButton>
                      </StyledToolTip>
                    )}
                  </StyledTypography>
                )}
              </TableCell>
            </React.Fragment>
          )
        })}

        <TableCell>
          {hasAccordian && (
            <IconButton aria-label="expand row" size="small">
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
          {isActionRequired && (
            <ActionMenu
              constituentId={row.uniqueConstituentIdentifier}
              listName={row.listName}
              actionMenuList={actionMenuList}
            />
          )}
        </TableCell>
      </StyledTableRow>

      {hasAccordian && (
        <TableRow>
          <StyledTableContactReportCell colSpan={100}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{margin: 1}}>
                {isMutating && <CircularProgress />}
                {!isMutating && !error && (
                  <Typography
                    variant="h6"
                    gutterBottom
                    component="div"
                    sx={{whiteSpace: prospectSummary.length > 0 ? 'break-spaces' : ''}}
                  >
                    {parse(
                      prospectSummary?.find((e) => e.id === row.uniqueConstituentIdentifier)?.content ||
                        row.contactReport ||
                        ''
                    )}
                  </Typography>
                )}
              </Box>
            </Collapse>
          </StyledTableContactReportCell>
        </TableRow>
      )}
    </>
  )
}

TableDataComponent.propTypes = {
  row: PropTypes.object,
  headers: PropTypes.oneOf([PropTypes.object, PropTypes.array]),
  handleRowCheckboxChange: PropTypes.func,
  showCheckboxes: PropTypes.bool,
  isActionRequired: PropTypes.bool,
  hasAccordian: PropTypes.bool,
  actionMenuList: PropTypes.array,
  handleTableRowClick: PropTypes.func,
  resetInterestToggle: PropTypes.bool,
  statesValue: PropTypes.array
}

export default TableDataComponent
